import { useEffect, useRef, useState } from 'react';
import PageTitle from '../../components/PageTitle';
import { useNavigate, useParams } from 'react-router-dom';
import ScriptSureIframeLayout from '../../components/ScriptSure/ScriptSureIframeLayout';
import { OrderStatusEnum } from '../../models/PatientModels';
import { useUpdateOrderStatusMutation } from '../../features/patient/patientService';
import ConfirmationModal from '../../components/Orders/ConfirmationModal';

const ApproveMedications = () => {
    const navigate = useNavigate();
    const { id: patientId = '', medicationId, orderId } = useParams();
    const [getHelpModalOpen, setGetHelpModalOpen] = useState<boolean>(false);

    return (
        <div>
            <PageTitle
                title="Review Medications"
                onClick={() => {
                    localStorage.removeItem('allMedications');
                    navigate(
                        `/patient/${patientId}/approve-medications/submitAll`,
                    );
                }}
            >
                <div className="get-help">
                    <button
                        type="button"
                        style={{ backgroundColor: 'rgb(33,150,243)' }}
                        className="btn btn-primary btn-sm"
                        onClick={() => setGetHelpModalOpen(true)}
                    >
                        Get Help
                    </button>
                </div>
            </PageTitle>
            <ScriptSureIframeLayout
                scriptSureSource={(
                    webAppUrl: string,
                    scriptSurePatientId: number,
                    scriptSureSessionToken: string,
                ) =>
                    `${webAppUrl}/widgets/prescription/${scriptSurePatientId}/${medicationId}?sessiontoken=${scriptSureSessionToken}&darkmode=off`
                }
                getHelpModalOpen={getHelpModalOpen}
                setGetHelpModalOpen={setGetHelpModalOpen}
                triggerFunction={() => navigate(
                    `/patient/${patientId}/approve-medications/submitAll`,
                )}
            />
        </div>
    );
};

export default ApproveMedications;
